import { useAnalytics, useAuth } from "reactfire";
import { useEffect } from "react";

function SetUserId() {
  const auth = useAuth();
  const analytics = useAnalytics();

  const userId =
    auth != null && auth.currentUser != null ? auth.currentUser.uid : null;

  useEffect(() => {
    if (userId != null) {
      analytics.setUserId(userId);
    }
  }, [userId, analytics]);

  return null;
}

export default SetUserId;
